var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-textarea" },
    [
      _c(
        "v-textarea",
        {
          class: { "gray--text text--lighten-1": _vm.disabled },
          attrs: {
            id: _vm.id,
            rows: _vm.rows,
            value: _vm.value,
            label: _vm.label,
            placeholder: _vm.placeholder,
            counter: _vm.counter,
            "error-messages": _vm.$formErrors(_vm.v),
            disabled: _vm.disabled,
            required: _vm.isRequired,
            maxLength: _vm.maxLength,
            "hide-details": _vm.hideDetails,
            color: "secondary",
            "auto-grow": "",
          },
          on: { input: _vm.input, blur: _vm.blur },
        },
        [
          _c(
            "span",
            {
              class: { "required-field": _vm.isRequired },
              attrs: { slot: "label", id: _vm.id },
              slot: "label",
            },
            [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }